import { Fragment } from 'react';
import '@wcj/dark-mode';
import { Link, NavLink, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import styles from './Layout.module.less';
import { ReactComponent as LogoIcon } from '../assets/logo.svg';
import { useMenus } from '../menus';
import { TransSelect } from '../components/TransSelect';
import { LogoIcon as Logo } from '../components/Logo';
import ColaToolSeo from '../components/ColaToolSeo';

const Divider = styled.div`
  border-top: 1px solid var(--color-border-muted);
`;

const Sup = styled.sup`
  position: absolute;
  font-weight: normal;
  font-size: 12px;
  margin-top: -4px;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  dark-mode {
    font-size: 14px;
    line-height: 12px;
  }
`;

const Label = styled.span`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  -webkit-line-clamp: 1;
`;

const LabelText = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ColaToolCurrent = styled.span`
  padding: 5px 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-fg-subtle);
  opacity: 0.65;
  cursor: default;
`;

const Article = styled.article`
  overflow: auto;
  flex: 1;
`;

export default function Layout() {
  const menus = useMenus();
  const { t } = useTranslation();
  const version = VERSION;
  return (
    <Fragment>
      <ColaToolSeo />
      <div className={styles.warpper}>
        <aside className="siderbar">
          <header>
            <h1>
              <a href="/" title="ColaTool" style={{ color: 'inherit', textDecoration: 'none', fontSize: 12, marginRight: 8 }}>
                ColaTool
              </a>
              <Link to="/">
                <LogoIcon width={21} />
                <span>
                  {t('title')}
                  <Sup>{version}</Sup>
                </span>
              </Link>
            </h1>
            <HeaderRight>
              <TransSelect />
              <dark-mode permanent></dark-mode>
            </HeaderRight>
          </header>
          <nav>
            {menus.map((item, idx) => {
              if (item.divider) {
                return <Divider key={idx}></Divider>;
              }
              if (item.colatoolSite) {
                if (item.current) {
                  return (
                    <ColaToolCurrent key={idx} title={item.label} aria-current="page">
                      <Logo
                        size="14px"
                        padding="0"
                        style={{ backgroundColor: 'transparent', borderRadius: 0 }}
                        src={item.logo}
                        alt={item.label}
                      />
                      <LabelText>{item.label}</LabelText>
                    </ColaToolCurrent>
                  );
                }
                return (
                  <a key={idx} href={item.href} title={item.label}>
                    <Label>
                      <Logo
                        size="14px"
                        padding="0"
                        style={{ backgroundColor: 'transparent', borderRadius: 0 }}
                        src={item.logo}
                        alt={item.label}
                      />
                      <LabelText>{item.label}</LabelText>
                    </Label>
                  </a>
                );
              }
              return (
                <NavLink key={idx} to={item.href || ''} title={item.label}>
                  <Label>
                    <Logo
                      size="14px"
                      padding="0"
                      style={{ backgroundColor: 'transparent', borderRadius: 0 }}
                      src={item.logo}
                      alt={item.label}
                    />
                    <span>{item.label}</span>
                  </Label>
                </NavLink>
              );
            })}
          </nav>
        </aside>
        <Article className="content">
          <Outlet />
        </Article>
      </div>
    </Fragment>
  );
}
